export const ORDER_CANCEL_TIME = {
  de: 1740000, // 29 minutes
  fr: 3600000 * 8, // 8 hours
};

export const ORDER_STATUS = {
  pending: 'pending',
  partiallyRefunded: 'partially_refunded',
  refunded: 'refunded',
  prepared: 'prepared',
  cancelled: 'cancelled',
};

export const FIRST_TIME_SERVICES = 'first_time_services';

export const ECOLOTRANS = 'ecolotrans';

export const CHRONOPOST = 'chronopost';

export const CHRONOFRESH = 'chronofresh';

export const DHL = 'dhl';

export const CARRIERS_MODAL_MESSAGE = [
  {
    carrier: 'paack',
    modalTextKey: 'paackMessage',
  },
  {
    carrier: 'ecolotrans',
    modalTextKey: 'ecolotransMessage',
  },
  {
    carrier: 'chrono',
    modalTextKey: 'chronoMessage',
  },
  {
    carrier: 'miist',
    modalTextKey: 'miistMessage',
  },
];
